export default "// .babelrc\n{\n  \"presets\": [\"@babel/preset-env\"]\n}\n";